import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import type { StringIndexedObject } from '@kanda-libs/ks-component-ts';

import { QueryType } from 'store/slices/query';

import { getInitialState, pushStateToQueryParams } from './helpers';

export interface UrlBooleanFlagsHook {
  values: StringIndexedObject<boolean>;
  toggleValue: (key: string) => void;
}

export default function useUrlBooleanFlags(
  keys: string[],
  queryType: QueryType = 'companies',
): UrlBooleanFlagsHook {
  const { push } = useHistory();
  const [values, setValues] = useState(getInitialState(keys));

  const toggleValue = useCallback(
    (key: string) => {
      if (keys.indexOf(key) === -1) {
        throw new Error(`Key ${key} is not in the list of keys`);
      }

      setValues((currentValues: StringIndexedObject<boolean>) => {
        const nextValues = {
          ...currentValues,
          [key]: !currentValues[key],
        };

        pushStateToQueryParams(push, nextValues);

        return nextValues;
      });
    },
    [values],
  );

  return {
    values,
    toggleValue,
  };
}
